import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=2ae47f79&scoped=true&"
import script from "./InputSwitch.vue?vue&type=script&lang=js&"
export * from "./InputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./InputSwitch.vue?vue&type=style&index=0&id=2ae47f79&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae47f79",
  null
  
)

export default component.exports